import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { changePath } from '@/lib/textutil'
import config from '@/config'
import en from './en'
import ko from './ko'

Vue.mixin({
  created() {
    if (this.localeChanged) {
      this.$evt.$on('localeChanged', this.localeChanged)
    }
  },

  destroyed() {
    if (this.localeChanged) {
      this.$evt.$off('localeChanged', this.localeChanged)
    }
  },

  methods: {
    L(path) {
      const changePathText = changePath(path)

      if (!this.langKey && this.$route) {
        this.langKey = this.upperCase(this.$route.path)
          .slice(1)
          .split('/')
          .join('.')
      }

      if (this.langKey) {
        const fullPath = `${this.langKey}.${path}`
        if (this.$te(fullPath)) {
          return this.$te(changePathText)
            ? this.$t(changePathText)
            : this.$t(fullPath)
        }
      }

      return this.$te(changePathText)
        ? this.$t(changePathText)
        : this.$t(`_common.${path}`)
    },

    C(path) {
      const changePathText = changePath(path)

      return this.$te(changePathText)
        ? this.$t(changePathText)
        : this.$t(`_common.${path}`)
    },

    upperCase(str) {
      const array = str.split(/_/)
      const result = []

      array.forEach((i) => {
        result.push(i.charAt(0).toUpperCase() + i.slice(1))
      })
      return result.join('')
    },
  },
})

const settingInfo = JSON.parse(localStorage.getItem('settingInfo'))
const locale = settingInfo ? settingInfo.language : config.languages.default

Vue.use(VueI18n)

export default new VueI18n({
  locale,
  messages: {
    en,
    ko,
  },
})
